import React from 'react';

import EmptyState from '@adsk/alloy-react-empty-state';
import { useLocale } from '@adsk/alloy-react-locale';

const PackagesPickerEmptyState = () => {
  const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));
  return (
    <EmptyState
      illustrationType={EmptyState.ILLUSTRATION_TYPES.FOLDER_EMPTY_GREY}
      description={T.translate('NO_DATA')}
    />
  );
};

export default PackagesPickerEmptyState;
